export default __webpack_public_path__ + "static/media/audioWave.72f8678f.png";